import { render, staticRenderFns } from "./edit-training.vue?vue&type=template&id=3f551885&scoped=true&"
import script from "./edit-training.vue?vue&type=script&lang=js&"
export * from "./edit-training.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f551885",
  null
  
)

export default component.exports